import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../../global-config'
import { useProductConfigContext } from '../../../../product'
import { TENANT } from '../../../../tenant'
import { productSearchAlgoliaAccessorGetDiscountData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetDiscountData'
import { productSearchAlgoliaAccessorGetOffersData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetOffersData'
import { productSearchAlgoliaAccessorStockStatusIsAvailable } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorStockStatusIsAvailable'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'
import { ProductSearchResultItemProductLinkWithIcon } from '../ProductSearchResultItemProductLinkWithIcon'

import { ProductSearchResultItemPriceContainerBpcReferencePrice } from './ProductSearchResultItemPriceContainerBpcReferencePrice'
import { ProductSearchResultItemPriceContainerDiscountBadge } from './ProductSearchResultItemPriceContainerDiscountBadge'
import { ProductSearchResultItemPriceContainerFormattedUnitPrice } from './ProductSearchResultItemPriceContainerFormattedUnitPrice'
import { ProductSearchResultItemPriceContainerListPrice } from './ProductSearchResultItemPriceContainerListPrice'
import { ProductSearchResultItemPriceContainerRetailPrice } from './ProductSearchResultItemPriceContainerRetailPrice'

export const ProductSearchResultItemPriceContainer: FC = () => {
  const { tenant } = useGlobalConfigContext()

  const { algoliaRecord, isMarketplace } = useProductSearchResultItemContext()
  const { discountBoundaries } = useProductConfigContext()

  if (!productSearchAlgoliaAccessorStockStatusIsAvailable(algoliaRecord)) {
    return null
  }

  const { hasDiscount, showDiscount } =
    productSearchAlgoliaAccessorGetDiscountData(
      algoliaRecord,
      discountBoundaries,
      tenant,
    )

  const { isSaeOffer } = productSearchAlgoliaAccessorGetOffersData(
    algoliaRecord,
    isMarketplace,
  )
  const showBpcReferencePrice =
    tenant === TENANT.COM &&
    algoliaRecord.bpc_product === true &&
    isSaeOffer &&
    !algoliaRecord.brandIntern?.toLowerCase().includes('skintist')

  return (
    <div className="flex flex-col items-start gap-0.5">
      <ProductSearchResultItemProductLinkWithIcon />
      <div className="flex gap-1">
        <ProductSearchResultItemPriceContainerDiscountBadge
          showBpcReferencePrice={showBpcReferencePrice}
        />
        <ProductSearchResultItemPriceContainerRetailPrice
          hasDiscount={hasDiscount}
        />
      </div>

      {showBpcReferencePrice ? (
        <ProductSearchResultItemPriceContainerBpcReferencePrice
          showDiscount={showDiscount}
        />
      ) : null}
      <ProductSearchResultItemPriceContainerFormattedUnitPrice classNames="text-s" />
      {!showBpcReferencePrice && (
        <ProductSearchResultItemPriceContainerListPrice
          showDiscount={showDiscount}
        />
      )}
    </div>
  )
}
